<template>
  <div id="GalleryPage" v-if="gallery_data != null">
    <ImageDialog ref="ImageDialog" :images="gallery_data.images" />
    <div class="row">
      <div class="header">
        <button @click="$router.push('/gallery/list/')" class="back_btn">
          返回相簿列表
        </button>
        <div class="content">
          <h2>
            {{ gallery_data.title }}
          </h2>
          <p>{{ gallery_data.create_time.slice(0, 10) }}</p>
        </div>
      </div>

      <div class="social_box">
        <button @click="ShareToLine">LINE 分享</button>
        <button @click="ShareToFB">Facebook 分享</button>
      </div>

      <div class="list">
        <div
          class="img_box"
          v-for="(item, item_index) in gallery_data.images"
          :key="`image_${item_index}`"
          @click="OpenDialog(item_index)"
        >
          <img v-lazy="item" alt="烏日 泰元宮" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs"
import ImageDialog from "@/components/Gallery/ImageDialog"
export default {
  name: "GalleryPage",
  components: {
    ImageDialog
  },
  data() {
    return {
      gallery_data: null
    }
  },
  methods: {
    OpenDialog(index) {
      this.$refs.ImageDialog.Open(index)
    },
    async GetGalleryData() {
      let result = await this.SendPostData(process.env.VUE_APP_BASE_API + 'gallery/get_gallery_image.php', qs.stringify({ id: this.$route.params.id }))
      if (result != "error") {
        console.log()
        this.gallery_data = JSON.parse(result.data)
      }
    },
    ShareToFB() {
      window.open(`https://www.facebook.com/sharer.php?u=${window.location.href}`, '_blank').focus();
    },
    ShareToLine() {
      window.open(`line://msg/text/${window.location.href}`, '_blank').focus();
    },
  },
  created() {
    this.GetGalleryData()
  }
}
</script>